const MiddleDot = () => {
  return <span>&#183;</span>;
};

export { MiddleDot };
